import { AgGrid } from "@jsq/ds/core";
import { ExportToolPanel } from "../ExportToolPanel";
import type { SideBarDefsParams } from "../types";

/**
 * Provides the configuration for the sidebar of the ag-grid. When `exportParams`
 * is provided, an Export tool panel is inserted between Filters and Columns
 * that triggers a CSV export of the payments list.
 */
export const sideBarDefs = (exportParams?: SideBarDefsParams): AgGrid.SideBarDef => {
  const toolPanels: AgGrid.ToolPanelDef[] = [
    {
      id: "filters",
      labelDefault: "Filters",
      labelKey: "filters",
      iconKey: "filter",
      toolPanel: "agFiltersToolPanel",
    },
  ];

  if (exportParams) {
    toolPanels.push({
      id: "export",
      labelDefault: "Export",
      labelKey: "export",
      iconKey: "export",
      toolPanel: ExportToolPanel,
      toolPanelParams: exportParams,
    });
  }

  toolPanels.push({
    id: "columns",
    labelDefault: "Columns",
    labelKey: "columns",
    iconKey: "columns",
    toolPanel: "agColumnsToolPanel",
    toolPanelParams: {
      suppressRowGroups: true,
      suppressPivotMode: true,
      suppressValues: true,
    },
  });

  return {
    position: "right",
    toolPanels,
  };
};
